import { setCity as _setCity } from '../legacy/sale.location.search.selector/api.js';
import { InputCityAutocomplete } from './InputCityAutocomplete';

export const CityChooser = {
	inheritAttrs: false,
	methods: {
		setCity(event, suggestion) {
			const setURL = this.$attrs['data-api-set'];
			const callbackName = this.$attrs['data-callback'];
			/** @type {function} */
			const callback = window[callbackName];

			_setCity(setURL, suggestion, callback);
		},
	},
	render(h) {
		return (
			<InputCityAutocomplete
				onSelected={ this.setCity }
				attrs={ this.$attrs }
			/>
		);
	}
}
